// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings {
  height: 100vh;
  height: 100dvh;
}

.settings__body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior-y: contain;
  padding: 4px var(--pad) calc(env(safe-area-inset-bottom, 0px) + 24px);
}

/* Reset the native fieldset chrome; it's used only for grouping semantics. */
.settings__group {
  border: 0;
  margin: 0;
  padding: 0;
  min-inline-size: 0;
}
.settings__label {
  padding: 0;
  font-family: var(--font-ui);
  font-weight: 600;
  font-size: 1rem;
  color: var(--palette-text);
}
.settings__desc {
  margin: 4px 0 14px;
  font-size: 0.9rem;
  color: var(--palette-text-muted);
}

.settings__name {
  margin-bottom: 28px;
}
.settings__name-input {
  width: 100%;
  min-height: 44px;
  margin-bottom: 12px;
  padding: 12px 14px;
  border: 1px solid var(--palette-border);
  border-radius: var(--r-btn);
  background: var(--palette-bg);
  color: var(--palette-text);
  font-family: var(--font-ui);
  font-size: 1rem;
}
.settings__name-input:focus-visible,
.settings__name-retry:focus-visible {
  outline: 2px solid var(--palette-secondary);
  outline-offset: 2px;
}
.settings__name-status {
  margin-top: 8px;
  font-size: 0.9rem;
  color: var(--palette-text-muted);
}
.settings__name-status:empty {
  margin-top: 0;
}
.settings__name-retry {
  min-height: 44px;
  padding: 0 8px;
  border: 0;
  background: transparent;
  color: var(--palette-secondary);
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
}

/* ── Board-font option cards ──────────────────────────────────── */
.fontopts {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.fontopt {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 14px;
  border: 1.5px solid var(--palette-border);
  border-radius: var(--r-card);
  background: var(--palette-surface);
  cursor: pointer;
}
.fontopt--on {
  border-color: var(--palette-primary);
  background: var(--palette-accent-soft);
}
/* Keyboard focus ring (visible only for keyboard users). */
.fontopt:has(.fontopt__input:focus-visible) {
  outline: 2px solid var(--palette-secondary);
  outline-offset: 2px;
}

/* Visually hidden radio — the label card is the visible control. */
.fontopt__input {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: 0;
  opacity: 0;
  pointer-events: none;
}

.fontopt__preview {
  display: flex;
  gap: 6px;
  flex: 0 0 auto;
}
.fontopt__tile {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid var(--palette-border-strong);
  border-radius: 9px;
  background: var(--palette-surface);
  color: var(--palette-text);
  font-weight: 600;
  font-size: 1.35rem;
  line-height: 1;
  /* font-family is inherited from .fontpreview--* so each option previews its
     own typeface regardless of the currently active board font. */
}
.fontpreview--serif {
  font-family: var(--font-board-serif);
}
.fontpreview--sans {
  font-family: var(--font-board-sans);
}

/* Text-size specimen: a fixed-width box showing "Aa" at the option's scale so
   the choice is previewed directly. Width matches the 3-tile font preview so
   both option groups' cards align. Sizes are in px (not rem) so the specimen
   is unaffected by the currently active text-size setting. */
.fontopt__preview[class*="textpreview--"] {
  width: 66px;
  height: 38px;
  align-items: center;
  justify-content: center;
  color: var(--palette-text);
  font-weight: 600;
  line-height: 1;
}
.textpreview--default {
  font-size: 20px;
}
.textpreview--large {
  font-size: 26px;
}
.textpreview--larger {
  font-size: 32px;
}

.fontopt__meta {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
.fontopt__name {
  font-weight: 600;
  font-size: 0.98rem;
  color: var(--palette-text);
}
.fontopt__desc {
  font-size: 0.84rem;
  color: var(--palette-text-muted);
}

.fontopt__check {
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  color: var(--palette-primary);
  opacity: 0;
}
.fontopt__check svg {
  width: 24px;
  height: 24px;
  display: block;
}
.fontopt--on .fontopt__check {
  opacity: 1;
}

.settings__channel {
  margin-top: 28px;
}

.settings__legal {
  margin-top: 32px;
  text-align: center;
}
.settings .premium-card {
  margin-top: 28px;
}

.settings__link {
  font-family: var(--font-ui);
  font-size: 0.8rem;
  color: var(--palette-secondary);
  text-decoration: none;
}

.settings__version {
  margin-top: 12px;
  text-align: center;
  font-family: var(--font-ui);
  font-size: 0.75rem;
  color: var(--palette-text-muted);
}
`, "",{"version":3,"sources":["webpack://./src/screens/settingsScreen.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,qEAAqE;AACvE;;AAEA,6EAA6E;AAC7E;EACE,SAAS;EACT,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,eAAe;AACjB;AACA;;EAEE,2CAA2C;EAC3C,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,aAAa;EACb,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,4BAA4B;EAC5B,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;AACA,2DAA2D;AAC3D;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;EAChD,kBAAkB;EAClB,kCAAkC;EAClC,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd;kEACgE;AAClE;AACA;EACE,oCAAoC;AACtC;AACA;EACE,mCAAmC;AACrC;;AAEA;;;6DAG6D;AAC7D;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,gCAAgC;AAClC","sourcesContent":[".settings {\n  height: 100vh;\n  height: 100dvh;\n}\n\n.settings__body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior-y: contain;\n  padding: 4px var(--pad) calc(env(safe-area-inset-bottom, 0px) + 24px);\n}\n\n/* Reset the native fieldset chrome; it's used only for grouping semantics. */\n.settings__group {\n  border: 0;\n  margin: 0;\n  padding: 0;\n  min-inline-size: 0;\n}\n.settings__label {\n  padding: 0;\n  font-family: var(--font-ui);\n  font-weight: 600;\n  font-size: 1rem;\n  color: var(--palette-text);\n}\n.settings__desc {\n  margin: 4px 0 14px;\n  font-size: 0.9rem;\n  color: var(--palette-text-muted);\n}\n\n.settings__name {\n  margin-bottom: 28px;\n}\n.settings__name-input {\n  width: 100%;\n  min-height: 44px;\n  margin-bottom: 12px;\n  padding: 12px 14px;\n  border: 1px solid var(--palette-border);\n  border-radius: var(--r-btn);\n  background: var(--palette-bg);\n  color: var(--palette-text);\n  font-family: var(--font-ui);\n  font-size: 1rem;\n}\n.settings__name-input:focus-visible,\n.settings__name-retry:focus-visible {\n  outline: 2px solid var(--palette-secondary);\n  outline-offset: 2px;\n}\n.settings__name-status {\n  margin-top: 8px;\n  font-size: 0.9rem;\n  color: var(--palette-text-muted);\n}\n.settings__name-status:empty {\n  margin-top: 0;\n}\n.settings__name-retry {\n  min-height: 44px;\n  padding: 0 8px;\n  border: 0;\n  background: transparent;\n  color: var(--palette-secondary);\n  font: inherit;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n/* ── Board-font option cards ──────────────────────────────────── */\n.fontopts {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.fontopt {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 14px;\n  border: 1.5px solid var(--palette-border);\n  border-radius: var(--r-card);\n  background: var(--palette-surface);\n  cursor: pointer;\n}\n.fontopt--on {\n  border-color: var(--palette-primary);\n  background: var(--palette-accent-soft);\n}\n/* Keyboard focus ring (visible only for keyboard users). */\n.fontopt:has(.fontopt__input:focus-visible) {\n  outline: 2px solid var(--palette-secondary);\n  outline-offset: 2px;\n}\n\n/* Visually hidden radio — the label card is the visible control. */\n.fontopt__input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.fontopt__preview {\n  display: flex;\n  gap: 6px;\n  flex: 0 0 auto;\n}\n.fontopt__tile {\n  width: 38px;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1.5px solid var(--palette-border-strong);\n  border-radius: 9px;\n  background: var(--palette-surface);\n  color: var(--palette-text);\n  font-weight: 600;\n  font-size: 1.35rem;\n  line-height: 1;\n  /* font-family is inherited from .fontpreview--* so each option previews its\n     own typeface regardless of the currently active board font. */\n}\n.fontpreview--serif {\n  font-family: var(--font-board-serif);\n}\n.fontpreview--sans {\n  font-family: var(--font-board-sans);\n}\n\n/* Text-size specimen: a fixed-width box showing \"Aa\" at the option's scale so\n   the choice is previewed directly. Width matches the 3-tile font preview so\n   both option groups' cards align. Sizes are in px (not rem) so the specimen\n   is unaffected by the currently active text-size setting. */\n.fontopt__preview[class*=\"textpreview--\"] {\n  width: 66px;\n  height: 38px;\n  align-items: center;\n  justify-content: center;\n  color: var(--palette-text);\n  font-weight: 600;\n  line-height: 1;\n}\n.textpreview--default {\n  font-size: 20px;\n}\n.textpreview--large {\n  font-size: 26px;\n}\n.textpreview--larger {\n  font-size: 32px;\n}\n\n.fontopt__meta {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n}\n.fontopt__name {\n  font-weight: 600;\n  font-size: 0.98rem;\n  color: var(--palette-text);\n}\n.fontopt__desc {\n  font-size: 0.84rem;\n  color: var(--palette-text-muted);\n}\n\n.fontopt__check {\n  flex: 0 0 24px;\n  width: 24px;\n  height: 24px;\n  color: var(--palette-primary);\n  opacity: 0;\n}\n.fontopt__check svg {\n  width: 24px;\n  height: 24px;\n  display: block;\n}\n.fontopt--on .fontopt__check {\n  opacity: 1;\n}\n\n.settings__channel {\n  margin-top: 28px;\n}\n\n.settings__legal {\n  margin-top: 32px;\n  text-align: center;\n}\n.settings .premium-card {\n  margin-top: 28px;\n}\n\n.settings__link {\n  font-family: var(--font-ui);\n  font-size: 0.8rem;\n  color: var(--palette-secondary);\n  text-decoration: none;\n}\n\n.settings__version {\n  margin-top: 12px;\n  text-align: center;\n  font-family: var(--font-ui);\n  font-size: 0.75rem;\n  color: var(--palette-text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
